import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ isAuthorized, children }) => {
  return isAuthorized ? children : <Navigate to="/access-denied" replace />;
};

export default ProtectedRoute;
